import { PermissaoEnum } from "core/resources/enums/permissao";

export const permissionsFor = {
  Dashboard: [
    PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Unidade.Editar,
    PermissaoEnum.Backoffice.Financeiro.Acordo.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.Acordo.toString(),
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.toString(),
    PermissaoEnum.Backoffice.Financeiro.Dashboard,
  ],
  CardMoradores: [
    PermissaoEnum.Backoffice.Administrativo.Unidade.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Unidade.Editar,
  ],
  CardAcordos: [
    PermissaoEnum.Backoffice.Financeiro.Acordo.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.Acordo.toString(),
  ],
  CardReceitas: [
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.toString(),
    PermissaoEnum.Backoffice.Financeiro.Dashboard,
  ],
  CardSaldo: [
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.toString(),
    PermissaoEnum.Backoffice.Financeiro.Dashboard,
  ],
  CardSaudeFinanceira: [
    PermissaoEnum.Backoffice.Financeiro.Arrecadacao.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.Arrecadacao.toString(),
    PermissaoEnum.Backoffice.Financeiro.ContasPagar.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.ContasPagar.toString(),
  ],
  CardReceitaDespesaResultado: [
    PermissaoEnum.Backoffice.Financeiro.ContasPagar.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.ContasPagar.toString(),
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.toString(),
    PermissaoEnum.Backoffice.Financeiro.ContasReceber.Visualizar,
    PermissaoEnum.Backoffice.Financeiro.Dashboard,
  ],
  CardMensagens: [
    PermissaoEnum.Backoffice.Administrativo.Mensagem.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Mensagem.toString(),
    PermissaoEnum.Backoffice.Administrativo.Portaria.Gerenciar,
  ],
  CardReserva: [
    PermissaoEnum.Backoffice.Administrativo.Reserva.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Reserva.toString(),
    PermissaoEnum.Backoffice.Administrativo.Reserva.Aprovar,
    PermissaoEnum.Backoffice.Administrativo.Reserva.Cancelar,
  ],
  CardManutencoes: [
    PermissaoEnum.Backoffice.Administrativo.Manutencao.Visualizar,
    PermissaoEnum.Backoffice.Administrativo.Manutencao.toString(),
  ],
};
